import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import http from "../../../../services/http.service";
import { apiPageLimit } from "../../../../constants/common";


const GET_NOTIFICATIONS = `/send/notifications`;


export const getNotifications = createAsyncThunk(
  "getNotifications",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit } = values;
      const response = await http.get(`${GET_NOTIFICATIONS}?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
